import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEditor } from "./useEditorState";
import { errMsg } from "@/lib/api";

export default function MyBlocks({ onAdd }) {
  const ed = useEditor();
  const [items, setItems] = useState(null);
  const [ask, setAsk] = useState(null);
  const load = () => ed.api.get("/library/my-blocks").then(({ data }) => setItems(data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const remove = async (b) => {
    setAsk(null);
    try { await ed.api.delete(`/library/my-blocks/${b.id}`); toast.success("Rimossa dalla libreria"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items) return <p className="text-sm text-slate-500">Caricamento…</p>;
  if (!items.length) return <p className="text-sm text-slate-500 py-6 text-center" data-testid="my-blocks-empty">Nessuna sezione salvata. Seleziona una sezione e usa «Salva nella libreria» nel pannello Proprietà.</p>;
  const cats = [...new Set(items.map((b) => b.category))];
  return (
    <div className="space-y-5 max-h-[55vh] overflow-auto pr-1" data-testid="my-blocks">
      {cats.map((c) => (
        <div key={c}>
          <p className="text-[11px] uppercase tracking-wider text-slate-500 mb-2">{c}</p>
          <div className="grid sm:grid-cols-2 gap-2">
            {items.filter((b) => b.category === c).map((b) => (
              <div key={b.id} className="group relative rounded-lg border hover:border-sky-400 hover:bg-sky-50/40 transition-colors">
                <button onClick={() => onAdd({ ...structuredClone(b.section), name: b.name, origin: "libreria" })} className="w-full text-left p-3 pr-9" data-testid={`my-block-${b.id}`}>
                  <p className="text-sm font-medium text-slate-900 truncate">{b.name}</p>
                  <p className="text-[11px] text-slate-500 mt-0.5 truncate">{b.source_project_name ? `da ${b.source_project_name}` : "Sezione salvata"}{b.section.type === "html" ? " · HTML" : " · React"}</p>
                </button>
                <button onClick={() => setAsk(b.id)} className="absolute top-2 right-2 p-1.5 text-slate-400 hover:text-red-600" aria-label="Rimuovi dalla libreria" data-testid={`my-block-delete-${b.id}`}><Trash2 size={13} /></button>
                {ask === b.id && (
                  <div className="absolute inset-0 rounded-lg bg-white/95 flex items-center justify-center gap-2 px-2" data-testid={`my-block-confirm-${b.id}`}>
                    <span className="text-xs text-slate-700">Eliminare dalla libreria?</span>
                    <Button size="sm" variant="destructive" className="h-7 text-xs" onClick={() => remove(b)} data-testid={`my-block-confirm-delete-${b.id}`}>Elimina</Button>
                    <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setAsk(null)} data-testid={`my-block-cancel-delete-${b.id}`}>Annulla</Button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
